import moment from "moment/moment";
import { Fragment, useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import {
  Archive,
  ChevronDown,
  Eye,
  MoreVertical,
  RefreshCcw,
  Trash2,
} from "react-feather";
import ReactPaginate from "react-paginate";
import generatePDF, { Margin, Resolution } from "react-to-pdf";
import { useReactToPrint } from "react-to-print";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  UncontrolledDropdown,
  UncontrolledTooltip,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import {
  convertDaysToMonthsAndYears,
  formatCurrency,
} from "../../../utility/Utils";
import classNames from "classnames";
import { EyeFill, Link45deg, ReceiptCutoff } from "react-bootstrap-icons";
import { Link, useSearchParams } from "react-router-dom";
import ReceiptForm from "../../receipts/components/form";
import axios from "axios";
import MergeReceipt from "./MergeReceipt";

const Receipts = ({ store }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const appView = searchParams.get("view");
  const [sort, setSort] = useState("desc");
  const [currentPage, setCurrentPage] = useState(1);
  const [modelShow, setModelShow] = useState(false);

  const [accounts, setAccounts] = useState([]);
  const [AllCustomers, setAllCustomers] = useState([]);
  const [selectedReceipts, setSelectedReceipts] = useState([]);

  // Create a reference for MergeReceipt component
  const mergeReceiptRef = useRef(null);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [receipts, setReceipts] = useState([]);
  const columns = [
    {
      name: "#",
      sortable: true,
      // minWidth: "10px",
      // sortField: "name",
      selector: (row) => row.receiptNo,
      cell: (row) => (
        <div className="d-flex justify-content-left align-items-center">
          <div className="d-flex flex-column">
            <span className="fw-bolder text-primary">
              #{row.receiptNo ?? ""}
            </span>
          </div>
        </div>
      ),
    },
    {
      name: "Date",
      // minWidth: "100px",
      // sortable: true,
      // sortField: "status",
      selector: (row) => row.createdAt,
      cell: (row) => (
        <span className="text-capitalize">
          {moment(row.createdAt).format("DD-MM-YYYY")}
        </span>
      ),
    },

    {
      name: "Invoice",
      sortable: true,
      // minWidth: "172px",
      // sortField: "floors",
      selector: (row) => row.invoiceId,
      cell: (row) => (
        <Link
          to={
            `invoices/${row.invoiceId?._id}` +
            (appView ? `?view=${appView}` : "")
          }
        >
          {" "}
          {Array.isArray(row.invoiceId)
            ? row.invoiceId.map((invoice) => invoice.invoiceNo).join(", ")
            : row.invoiceId.invoiceNo}
        </Link>
      ),
    },
    {
      name: "Amount",
      // minWidth: "138px",
      // sortable: true,
      // sortField: "discount",
      selector: (row) => row.amount,
      cell: (row) => (
        <Badge color="success" className="text-capitalize fw-bolder">
          ${row.amount}
        </Badge>
      ),
    },

    {
      name: "Reference",

      selector: (row) => row.reference,
      cell: (row) => <span className="text-capitalize">{row.reference}</span>,
    },

    {
      name: "User",

      selector: (row) => row.createdBy,
      cell: (row) => row.createdBy?.username,
    },
    {
      name: "Actions",
      minWidth: "100px",
      cell: (row) => (
        <div className="column-action d-flex align-items-center justify-content-center">
          <Link
            to={`/receipts/${row._id}` + (appView ? `?view=` + appView : ``)}
            className="mx-1"
            id={`pw-tooltip-${row._id}`}
          >
            <Eye size={17} />
          </Link>
          <UncontrolledTooltip placement="top" target={`pw-tooltip-${row._id}`}>
            Print Receipt
          </UncontrolledTooltip>

          <UncontrolledDropdown>
            <DropdownToggle tag="div" className="btn btn-sm">
              <MoreVertical size={14} className="cursor-pointer" />
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem
                tag="a"
                href="/"
                className="w-100"
                onClick={(e) => {
                  e.preventDefault();
                  dispatch(selectReceipt(row));
                  setModalShow(true);
                }}
              >
                <Archive size={14} className="me-50" />
                <span className="align-middle">Edit</span>
              </DropdownItem>
              <DropdownItem
                tag="a"
                href="/"
                className="w-100"
                onClick={(e) => {
                  e.preventDefault();
                  handleConfirmDelete(row._id, row.name);
                }}
              >
                <Trash2 size={14} className="me-50" />
                <span className="align-middle">Delete</span>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>
      ),
    },
  ];

  const handlePagination = (page) => {
    const startIndex = page.selected * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;

    const currentPageData = store.data.receipts?.slice(startIndex, endIndex);

    setReceipts(currentPageData);
    setCurrentPage(page.selected + 1);
  };

  const CustomPagination = () => {
    const count = Number(Math.ceil(store.data.receipts.length / rowsPerPage));

    return (
      <ReactPaginate
        previousLabel={""}
        nextLabel={""}
        pageCount={count || 1}
        activeClassName="active"
        forcePage={currentPage !== 0 ? currentPage - 1 : 0}
        onPageChange={(page) => handlePagination(page)}
        pageClassName={"page-item"}
        nextLinkClassName={"page-link"}
        nextClassName={"page-item next"}
        previousClassName={"page-item prev"}
        previousLinkClassName={"page-link"}
        pageLinkClassName={"page-link"}
        containerClassName={
          "pagination react-paginate justify-content-end my-2 pe-1"
        }
      />
    );
  };

  const ToggleRentModal = (show) => {
    setModelShow(false);
  };

  const getAccounts = async () => {
    try {
      var { status, data } = await axios.get(
        "/accountings/accounts/hierarchy/64089b489d122d411c67abe4"
      );
      if (status == 200) {
        setAccounts(data?.data ?? []);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getAllCustomers = async () => {
    try {
      var { status, data } = await axios.get("/customers/list");
      if (status == 200) {
        setAllCustomers(data?.data ?? []);
      }
    } catch (error) {
      console.log(error);
      ErrorHandler(error);
    }
  };

  useEffect(() => {
    getAccounts();
    getAllCustomers();
  }, []);

  useEffect(() => {
    setReceipts(store.data.receipts?.slice(0, rowsPerPage));
  }, [store]);

  // Handle row selection
  const handleSelectedRowsChange = ({ selectedRows }) => {
    setSelectedReceipts(selectedRows);
  };

  // Handle print logic for MergeReceipt component
  const handlePrint = useReactToPrint({
    content: () => mergeReceiptRef.current,
    documentTitle: "Merged Receipts",
    pageStyle: `
      @page {
        size: A4 portrait;
        margin: 10mm !important;
      }
      @media print {
        html, body {
          height: auto !important;
          overflow: visible !important;
          -webkit-print-color-adjust: exact;
        }
      }
    `,
  });

  const handleDownload = () => {
    // Temporarily make the element visible
    if (mergeReceiptRef.current) {
      mergeReceiptRef.current.style.display = "block";

      // Use generatePDF to create the PDF
      const options = {
        filename: "merged-receipts.pdf",
        resolution: Resolution.HIGH,
        page: {
          margin: Margin.SMALL,
        },
        canvas: {
          qualityRatio: 1,
        },
        overrides: {
          pdf: {
            compress: true,
            format: "a4",
            unit: "mm",
          },
          canvas: {
            useCORS: true,
          },
        },
      };

      generatePDF(mergeReceiptRef, options)
        .then(() => {
          // Hide the element again after the PDF is generated
          mergeReceiptRef.current.style.display = "none";
        })
        .catch((error) => {
          console.error("Failed to generate PDF:", error);
          mergeReceiptRef.current.style.display = "none"; // Ensure it's hidden in case of an error
        });
    }
  };

  return (
    <Fragment>
      <ReceiptForm
        show={modelShow}
        ShowModal={ToggleRentModal}
        data={{
          accounts,
          customers: AllCustomers,
        }}
        appView={appView}
      />
      <Card>
        <CardHeader
          tag="h4"
          className="d-flex justify-content-between align-items-center"
        >
          <CardTitle>Customers's Receipt List</CardTitle>
          <div>
            <Button
              color="primary"
              onClick={() => setModelShow(true)}
              className="me-1"
            >
              New Receipt
            </Button>
            {selectedReceipts.length > 0 && (
              <>
                <Button color="warning" onClick={handlePrint} className="me-1">
                  Print Receipts
                </Button>
                <Button
                  color="success"
                  onClick={handleDownload}
                  className="me-1"
                >
                  Download Receipts
                </Button>
              </>
            )}
          </div>
        </CardHeader>
        <CardBody>
          <div className="react-dataTable user-view-account-projects">
            <DataTable
              subHeader
              sortServer
              pagination
              responsive
              paginationServer
              striped
              columns={columns}
              sortIcon={<ChevronDown />}
              className="react-dataTable react-dataTable-selectable-rows"
              paginationComponent={CustomPagination}
              data={receipts}
              selectableRows
              onSelectedRowsChange={handleSelectedRowsChange}
            />
          </div>
        </CardBody>
      </Card>

      {/* MergeReceipt component hidden but available for print */}
      <div
        style={{ display: "none" }}
        className="d-print-block"
        ref={mergeReceiptRef}
      >
        <MergeReceipt receiptData={selectedReceipts} store={store} />
      </div>
    </Fragment>
  );
};

export default Receipts;
